/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */

import Vue from "vue"
import Router from "vue-router"
import Meta from "vue-meta"

import account from "./account"
import admin from "./admin"
import admin_user from "./admin_user"
import form from "./form"
import general from "./general"
import project from "./project"
import statistics from "./statistics"

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  mode: "history",
  routes: [
    ...account,
    ...general,
    ...project,
    ...form,
    ...statistics,
    ...admin,
    ...admin_user,
    // default route
    { path: "*", redirect: { name: "Home" } }
  ]
})

// Garde de navigation globale
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !isAuthenticated()) {
    // Rediriger vers la page de connexion si non authentifié
    next({ name: "Login" })
  } else {
    // Permettre l'accès à la route
    next()
  }
})

function isAuthenticated() {
  // Logique pour vérifier l'authentification de l'utilisateur
  return !!localStorage.getItem("authToken")
}

export default router
